import { PropertySubsetValidator } from 'types/api';
import { StockLotCRUDSchema } from 'types/inventory';
import { StockLocationSchemaLite } from 'types/clientV2/stockLocations';
import {
  HandlingRequestSchemaLite,
  StockLotSchemaLite,
} from 'types/clientV2/stock';
import { MismatchReason } from 'views/warehouse/utils';

export enum MoveWarningType {
  CUSTOMER_MISMATCH = 'customer_mismatch',
  ASSIGNMENT_MISMATCH = 'assignment_mismatch',
  UNASSIGNED_BIN = 'unassigned_bin',
}

export type StockLotSubset = PropertySubsetValidator<
  StockLotCRUDSchema | StockLotSchemaLite,
  'id' | 'org' | 'lotId' | 'team'
>;

export type HandlingRequestSubset = PropertySubsetValidator<
  HandlingRequestSchemaLite,
  'requestType' | 'kitRequestIdViaLot' | 'org' | 'stockLot'
>;

export type MoveWarningData = {
  stockLot: StockLotSubset;
  destination: StockLocationSchemaLite;
  reason: MoveWarningType;
  handlingRequest?: HandlingRequestSubset | null;
  mismatchReasons?: MismatchReason[];
};

export type MoveWarningContextType = {
  dismissWarning: () => void;
  confirmTransfer: () => void;
  warningData: MoveWarningData | null;
  isWarningOpen: boolean;
  setWarningData: (data: MoveWarningData | null) => void;
  setIsWarningOpen: (open: boolean) => void;
  validateMove: (
    stockLot: StockLotSubset,
    destination: StockLocationSchemaLite,
    handlingRequest?: HandlingRequestSubset | null
  ) => Promise<MoveWarningData | null>;
  validateMoveAndShowWarning: (
    stockLot: StockLotSubset,
    destination: StockLocationSchemaLite,
    handlingRequest?: HandlingRequestSubset | null
  ) => Promise<MoveWarningData | null>;
};
